export default "1.2.0";
export const MANUFACTURE_DATE = "2026-05";



// WEBPACK FOOTER //
// ./src/version.ts